import api from './api';

export const filter = async ({ filters, select }) => {
    const client = await api.getClient();
    return api.handleSuccess(await client.GetNodes({
        filters: JSON.stringify(filters ?? null),
        select: JSON.stringify(select)
     }));
};


export const get = async (id) => {
    const client = await api.getClient();
    return api.handleSuccess(await client.GetNode({ nodeId: id }));
};

export const updateSerialNumber = async (nodeId, serialNumber) => {
    const client = await api.getClient();
    const response = await client.request({
        method: 'PATCH',
        url: `/api/v1/nodes/${nodeId}`,
        data: { data: { serialNumber } },
    });
    return api.handleSuccess(response);
};

export default {
    filter, 
    get, 
    updateSerialNumber
}
